<template>
  <div>
    <Breadcrumbs main="" :title="$t('lbl_EMPBE_SupplierList')" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div>
        <localization :language="kendoLang">
          <intl :locale="kendoLang">
            <Grid ref="grid" id="SupplierList_grid" :data-items="gridData" :resizable="true" :reorderable="true" :sortable="false"
              :pageable="gridPageable" :groupable="true" :group="group" :sort="sort" :filter="filter" :take="take"
              :skip="skip" :columns="columns" :column-menu="false" :filterable="false" :selectable="true" :selected-field="selectedField"
              @headerselectionchange="onHeaderSelectionChange" @datastatechange="dataStateChange"
              @selectionchange="onSelectionChange" @pagechange="pageChangeHandler" :total="totalRows" :loader="loader">
              <toolbar>
                <div class="supplier-toolbar-inner p-t-5 p-b-5">
                  <b-dropdown id="dropdown-1" :text="$t('lbl_EMPBE_BatchAction')" style="width: 200px"
                    variant="primary">
                    <!-- <b-dropdown-item @click="resetPassword(0)" v-bind:t_label="'EMPBE_Backend_btnBatchResetPassword'">{{
                      $t("lbl_EMPBE_ResetSelectedPassword") }}</b-dropdown-item> -->
                      <!-- <b-dropdown-item>透過電郵發送已選擇供應商帳號密碼</b-dropdown-item> -->
                    <!-- <b-dropdown-divider></b-dropdown-divider> -->
                    <b-dropdown-item @click="sendAccountPassword(0)" v-bind:t_label="'EMPBE_Backend_btnBatchSendAccountPassword'">{{
                      $t("lbl_EMPBE_SendAccountPassword") }}</b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="submitReminder(0)" v-bind:t_label="'EMPBE_Backend_btnBatchSubmitReminder'">{{
                      $t("lbl_EMPBE_SubmitReminder") }}</b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="submitReminderAll()" v-bind:t_label="'EMPBE_Backend_btnBatchSubmitReminderAll'">{{
                      $t("lbl_EMPBE_SubmitReminderAll") }}</b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="researchCompany(0, 'QL')" v-bind:t_label="'EMPBE_Backend_btnBatchQuickLaunchResearch'">
                      {{ "Quick Launch Research" }}
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="researchCompany(0, 'NC')" v-bind:t_label="'EMPBE_Backend_btnNewCustomerResearch_'">
                      {{ "New Customer Research" }}
                    </b-dropdown-item>
                    
                    <b-dropdown-divider v-show="false"></b-dropdown-divider>
                    <b-dropdown-item v-b-toggle="'stopAccount'" variant="danger" v-show="false"
                      v-bind:t_label="'EMPBE_Backend_btnBatchDisablePassword'">{{ $t("lbl_EMPBE_StopSelectedAccount") }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-form-input
                    type="text"
                    class="supplier-toolbar-search"
                    :placeholder="$t('lbl_EMPBE_SearchWord')"
                    v-model="searchWord"
                    @keyup.enter="onFilter"
                  />
                  <b-button
                    variant="primary"
                    class="supplier-toolbar-search-btn"
                    style="width: 150px"
                    @click="onFilter"
                    v-bind:t_label="'EMPBE_Backend_btnSearch'"
                  >{{ $t("lbl_EMPBE_Search") }}</b-button>
                  <div class="supplier-toolbar-filter">
                    <selection ControlId="SupplierSalesCodeId"
                      name="SupplierSalesCode" v-model="salesPersonFilter.Selected"
                      :key="'sales-code-options-' + salesCodeListFromApi.length"
                      :options="salesPersonFilterOptions" :multiple="false"
                      :clearable="false" :preselect-first="true" :isShowTitle="false" />
                  </div>
                  <div class="supplier-toolbar-filter">
                    <selection ControlId="SupplierEBoothTypeId"
                      name="SupplierEBoothType" v-model="eBoothFilter.Selected"
                      :options="eBoothFilterOptions" :multiple="false"
                      :clearable="false" :preselect-first="true" :isShowTitle="false" />
                  </div>
                </div>
              </toolbar>
              <template v-slot:selectedTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  <input type="checkbox" id="checkbox" v-model="rowSelected" role="button" />
                </td>
              </template>
              <template v-slot:companyNameTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  <!-- {{ getCompanyNameWithLang(props.dataItem) }}<br /> -->
                  <!-- <i class="fa fa-map-marker m-r-5"></i>{{ props.dataItem.Booth }}<br /> -->
                  <!-- {{ props.dataItem.displayName }}<br /> -->
                  <div class="text-wrap-anywhere" v-if="langid === '950'">
                    {{ (props.dataItem.companyNameTc != '') ? (props.dataItem.companyNameTc ==
                      props.dataItem.companyNameEn ? "" : props.dataItem.companyNameTc) : (props.dataItem.companyNameSc ==
                        props.dataItem.companyNameEn ? "" : props.dataItem.companyNameSc) }}
                  </div>
                  <div class="text-wrap-anywhere" v-else>
                    {{ (props.dataItem.companyNameSc != '') ? (props.dataItem.companyNameSc ==
                      props.dataItem.companyNameEn ? "" : props.dataItem.companyNameSc) : (props.dataItem.companyNameTc ==
                        props.dataItem.companyNameEn ? "" : props.dataItem.companyNameTc) }}
                  </div>
                  <div class="text-wrap-anywhere" v-if="props.dataItem.companyNameEn != ''">
                    {{ props.dataItem.companyNameEn }}
                  </div>
                  <b-dropdown :id="'dropdown-'+props.dataItem.accountId" :text="$t('lbl_EMPBE_Action')" class="p-l-0 btn-lg actionBtn"
                    variant="primary">
                    <b-dropdown-item v-b-toggle="'supplier'" @click="openSidebar(props.dataItem)" v-bind:t_label="'EMPBE_Backend_btnDetail_' + props.dataItem.accountId
                      ">
                      {{ $t("lbl_EMPBE_WatchDetailInfo") }}
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="resetPassword(props.dataItem.accountId)" v-bind:t_label="'EMPBE_Backend_btnResetPassword_' + props.dataItem.accountId
                      ">{{ $t("lbl_EMPBE_ResetAccPassword") }}</b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="researchCompany(props.dataItem.accountId, 'QL')" v-bind:t_label="'EMPBE_Backend_btnQuickLaunchResearch_' + props.dataItem.accountId
                      ">{{ "Quick Launch Research" }}</b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="researchCompany(props.dataItem.accountId, 'NC')" v-bind:t_label="'EMPBE_Backend_btnNewCustomerResearch_' + props.dataItem.accountId
                      ">{{ "New Customer Research" }}</b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="researchSubmit(props.dataItem.accountId)" v-bind:t_label="'EMPBE_Backend_btnResearchSubmit_' + props.dataItem.accountId
                      ">{{ "Submit AI Research Preview" }}</b-dropdown-item>

                     <!-- <b-dropdown-item>透過電郵發送供應商帳號密碼</b-dropdown-item> -->
                    <b-dropdown-divider v-show="props.dataItem.haveAd"></b-dropdown-divider>
                    <b-dropdown-item 
                      v-show="props.dataItem.haveAd"
                      @click="sendAccountPassword(props.dataItem.accountId)"
                      v-bind:t_label="'EMPBE_Backend__btnSendAccountPassword_' + props.dataItem.accountId">
                      {{ $t('lbl_EMPBE_SendAccountPassword') }}</b-dropdown-item>

                    <b-dropdown-divider v-show="props.dataItem.haveAd"></b-dropdown-divider>
                    <b-dropdown-item v-show="props.dataItem.haveAd" @click="submitReminder(props.dataItem.accountId)"
                      v-bind:t_label="'EMPBE_Backend__btnResetPassword_' + props.dataItem.accountId">
                      {{ $t('lbl_EMPBE_SubmitReminder') }}</b-dropdown-item>
                   

                    <b-dropdown-divider v-show="false"></b-dropdown-divider>
                    <b-dropdown-item v-b-toggle="'stopAccount'" variant="danger" v-show="false" v-bind:t_label="'EMPBE_Backend_btnDisableAccount_' + props.dataItem.accountId
                      ">{{ $t("lbl_EMPBE_DisableAccount") }}
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </template>
              <template v-slot:EMP_CompanyIdTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.empCompanyId }}
               </td>
              </template>
               <template v-slot:Prospect_IDTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.prospectId }}
               </td>
              </template>
               <template v-slot:PUB_IOCodeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.pubIoNo }}
               </td>
              </template>
               <template v-slot:Contract_NoTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.contractNo }}
               </td>
              </template>
               <template v-slot:PUB_SalesCodeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.salesCodePub }}
               </td>
              </template>
               <template v-slot:CRM_SalesCodeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.salesCodeCrm }}
               </td>
              </template>
              
              
              <template v-slot:accountTypeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ getMemberGradeWithLang(props.dataItem) }}<br />
                  <span class="badge badge-light" v-if="!props.dataItem.isActive">{{
                    $t("lbl_EMPBE_Disabled")
                  }}</span>
                </td>
              </template>
              <template v-slot:packageTypeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  <div v-for="(item,index) in getPackageNameArray(props.dataItem)"  :key="index" >
                    {{ item }}
                  </div>
                </td>
              </template>
              <template v-slot:membershipExpiryDateTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ DisplayDate(props.dataItem.membershipExpiryDate, "-") }}<br />
                  <span class="badge badge-light" v-if="!props.dataItem.isActive">{{
                    $t("lbl_EMPBE_Disabled")
                  }}</span>
                </td>
              </template>
              <template v-slot:adExpiryDateTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ DisplayDate(props.dataItem.adExpiryDate, "-") }}<br />
                  <span class="badge badge-light" v-if="!props.dataItem.isActive">{{
                    $t("lbl_EMPBE_Disabled")
                  }}</span>
                </td>
              </template>
            </Grid>
          </intl>
        </localization>
      </div>
    </div>
    <!-- Container-fluid Ends-->
    <div class="b-sidebar-backdrop bg-dark" style="z-index: 100" v-if="sidebarMenu"
      @click="handleSidebarHide(selectedAccoountId)"></div>
    <b-sidebar :title="getCompanyNameWithLang(selectedDataItem)" :id="'supplier'" :ref="'supplier'" bg-variant="white"
      right :shadow="true" v-model="sidebarMenu">
      <!-- <supplierDetail :supplierId="'1004320'"></supplierDetail> -->
      <supplierDetail 
        :supplierId="selectedAccoountId" 
        :simulatedSupplier="selectedDataItem" 
        :sidebarStrus="sidebarMenu"
        :id="'supplier'" 
        :ref="'supplier_detail'"
        :openTabIndex="`0`"
      />
      <div class="d-flex" slot="header" style="align-items: center;">
        <button type="button" style="border: none; background-color: transparent;margin-top: -8px;"
          @click="handleSidebarHide(selectedAccoountId)">
          <i class="icon-close f-14"></i>
        </button>
        <div style="font-size: 18px;color: rgba(0, 0, 0, 0.80);align-items: center;padding-left:8px;">{{ $t('lbl_EMPBE_EditMode')}}</div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { adminService } from "../../_services";
import { clearAdminDeepLinkFromRoute } from "../../_helpers/adminDeepLinkRoute";
import supplierDetail from "./supplierDetail/default.vue";
import DisableItemVue from "./RightPopUp/DisableItem.vue";
import ResetPasswordVue from "./RightPopUp/ResetPassword.vue";
import { Grid, GridToolbar } from "@progress/kendo-vue-grid";
import { process } from "@progress/kendo-data-query";
import { computed } from "vue";
import {
  IntlProvider,
  load,
  LocalizationProvider,
  loadMessages,
} from "@progress/kendo-vue-intl";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import numbers from "cldr-numbers-full/main/zh-Hans/numbers.json";
import caGregorian from "cldr-dates-full/main/zh-Hans/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/zh-Hans/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/zh-Hans/timeZoneNames.json";
load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  caGregorian,
  dateFields,
  timeZoneNames
);

export default {
  components: {
    supplierDetail,
    DisableItemVue,
    ResetPasswordVue,
    Grid: Grid,
    toolbar: GridToolbar,
    localization: LocalizationProvider,
    intl: IntlProvider,
  },
  data() {
    return {
      type: "",
      dirty: false,
      sidebarMenu: false,
      items: [],
      loader: false,
      gridData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      rowSelected: [],
      skip: 0,
      take: 5,
      group: [],
      sort: [],
      filter: this.$route.query.pending
        ? {
          filters: [
            {
              logic: "or",
              filters: [
                {
                  field: "adInfoFieldTc",
                  operator: "eq",
                  value: this.$t("lbl_EMPBE_Pending"),
                },
              ],
            },
          ],
          logic: "and",
        }
        : (this.$route.query.companyId || this.$route.query.accountid)
          ? {
            logic: "or",
            filters: [
              {
                field: "accountId",
                operator: "contains",
                value: this.$route.query.companyId || this.$route.query.accountid,
              },
            ],
          }
          : null, //[20231005][JWS] Defailt loading pending if query have pending
      gridPageable: {
        buttonCount: 5,
        info: true,
        type: "numeric",
        pageSizes: true,
        previousNext: true,
      },
      searchWord: "",
      salesPersonFilter: {
        Selected: "All",
      },
      eBoothFilter: {
        Selected: "All",
      },
      selectedField: "selected",
      memberGradeList: [],
      selectedDataItem: {},
      selectedAccoountId: '0',
      isFirstLoad: true,
      packageTypeList: [],
      salesCodeListFromApi: [],
      salesCodeDetailOptions: [],
    };
  },
  computed: {
    companyName() {
      if (
        this.langid === "950" &&
        this.props.dataItem.companyNameTc !== this.props.dataItem.companyNameEn
      ) {
        return this.props.dataItem.companyNameTc;
      } else if (
        this.props.dataItem.companyNameSc !== this.props.dataItem.companyNameEn
      ) {
        return this.props.dataItem.companyNameSc;
      } else {
        return this.props.dataItem.companyNameEn;
      }
    },
    kendoLang() {
      var langid = localStorage.getItem("currentLangId");
      switch (langid) {
        case "1252":
          return "en-US";
        case "950":
          return "zh-Hant";
        case "936":
          return "zh-Hans";
        default:
          return "zh-Hans";
      }
    },
    selectedDataItems() {
      return this.gridData.data.filter((item) => item.selected === true);
    },
    areAllSelected() {
      return (
        this.selectedDataItems.length === this.gridData.data.length &&
        this.selectedDataItems.length !== 0
      );
    },
    salesPersonFilterOptions() {
      const codes =
        this.salesCodeListFromApi && this.salesCodeListFromApi.length
          ? this.salesCodeListFromApi.map((code) => ({ id: code, label: code }))
          : [];
      const allLabel =
        this.langid === "1252"
          ? "All " + this.$t("lbl_EMPBE_ReportAll_Table_SalesCode")
          : "全部" + this.$t("lbl_EMPBE_ReportAll_Table_SalesCode");
      return [{ id: "All", label: allLabel }, ...codes];
    },
    eBoothFilterOptions() {
      const allEboothLabel =
        this.langid === "1252"
          ? "All " + this.$t("lbl_EMPBE_eBoothType")
          : "全部" + this.$t("lbl_EMPBE_eBoothType");
      return [
        { id: "All", label: allEboothLabel },
        { id: "A+", label: this.$t("lbl_EMPBE_GradeAMore") },
        { id: "A", label: this.$t("lbl_EMPBE_GradeA") },
        { id: "B", label: this.$t("lbl_EMPBE_GradeB") },
        { id: "C", label: this.$t("lbl_EMPBE_GradeC") },
        { id: "BASIC", label: this.$t("lbl_emp2_BasicEbooth") },
        { id: "FREE", label: this.$t("lbl_EMPBE_FreeEBooth") },
      ];
    },
    columns() {
      var res = [];
      return [
        {
          field: "selected",
          title: " ",
          width: "45px",
          columnMenu: false,
          headerSelectionValue: this.areAllSelected,
        },
        {
          field: "companyField",
          title: this.$t("Lbl_CompanyName"),
          cell: "companyNameTemplate",
          columnMenu: false,
          width: "150px",
        },
        {
          field:
            this.langid == "1252"
              ? "eBoothGradeNameEn"
              : this.langid == "950"
                ? "eBoothGradeNameTc"
                : "eBoothGradeNameSc",
          title: this.$t("lbl_EMPBE_eBoothType"),
          columnMenu: false,
          width: "150px",
        },
        {
          field:
            this.langid == "1252"
              ? "packageNameEn"
              : this.langid == "950"
                ? "packageNameTc"
                : "packageNameSc",
          title: this.$t("lbl_EMPBE_SponsorshipAdPackage"),
          cell: "packageTypeTemplate",
          columnMenu: false,
          width: "200px",
        },
        {
          field: "membershipExpiryDate",
          title: this.$t("lbl_EMPBE_MemberEffectiveDate"),
          cell: "membershipExpiryDateTemplate",
          columnMenu: false,
          format: "{0:D}",
          width: "180px",
        },
        {
          field: "adExpiryDate",
          title: this.$t("lbl_EMPBE_AdEffectiveDate"),
          cell: "adExpiryDateTemplate",
          columnMenu: false,
          format: "{0:D}",
          width: "180px",
        },
        {
          field:"empCompanyId",
          title: this.$t("lbl_EMPBE_AdminOrder_EMP_CompanyId"),
          cell: "EMP_CompanyIdTemplate",
          width: "150px",
        },
        {
          field:"prospectId",
          title: this.$t("lbl_EMPBE_AdminOrder_Prospect_ID"),
          cell: "Prospect_IDTemplate",
          width: "150px",
        },
        {
          field:"pubIoNo",
          title: this.$t("lbl_EMPBE_AdminOrder_PUB_IO"),
          cell: "PUB_IOCodeTemplate",
          width: "150px",
        },
        {
          field:"contractNo",
          title: this.$t("lbl_EMPBE_AdminOrder_Contract_No"),
          cell: "Contract_NoTemplate",
          width: "150px",
        },      
        {
          field:"salesCodePub",
          title: this.$t("lbl_EMPBE_AdminOrder_PUB_SalesCode"),
          cell: "PUB_SalesCodeTemplate",
          width: "150px",
        },     
        {
          field:"salesCodeCrm",
          title: this.$t("lbl_EMPBE_AdminOrder_CRM_SalesCode"),
          cell: "CRM_SalesCodeTemplate",
          width: "150px",
        },   
      ];
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
  },
  created() {
    this.gridData = this.getData(this.items);
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.LoadFilterBasicData();
    this.filter = this.buildListFilter();
    this.LoadSupplierData();
  },
  watch: {
    sidebarMenu(val) {
      if (!val) {
        clearAdminDeepLinkFromRoute(this.$router);
      }
    },
    "salesPersonFilter.Selected"() {
      this.applyToolbarFilters();
    },
    "eBoothFilter.Selected"() {
      this.applyToolbarFilters();
    },
  },
  methods: {
    buildListFilter() {
      const parts = [];
      const inputValue = (this.searchWord || "").trim();

      if (inputValue !== "") {
        parts.push({
          logic: "or",
          filters: [
            {
              field: "companyField",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "memberGradeEn",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "memberGradeTc",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "memberGradeSc",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "accountId",
              operator: "contains",
              value: inputValue,
            },
          ],
        });
      } else if (this.$route.query.pending) {
        parts.push({
          logic: "or",
          filters: [
            {
              field: "adInfoFieldTc",
              operator: "eq",
              value: this.$t("lbl_EMPBE_Pending"),
            },
          ],
        });
      } else if (this.$route.query.companyId || this.$route.query.accountid) {
        parts.push({
          logic: "or",
          filters: [
            {
              field: "accountId",
              operator: "contains",
              value: this.$route.query.companyId || this.$route.query.accountid,
            },
          ],
        });
      }

      if (parts.length === 0) {
        return null;
      }
      if (parts.length === 1) {
        return parts[0];
      }
      return { logic: "and", filters: parts };
    },
    applyToolbarFilters() {
      this.skip = 0;
      this.filter = this.buildListFilter();
      this.LoadSupplierData();
    },
    LoadFilterBasicData() {
      adminService.GetSupplierList_FilterBasicData().then((res) => {
        const payload =
          res && res.isSuccessful !== undefined ? res.data : res;
        if (!payload || Array.isArray(payload)) {
          return;
        }
        const details =
          payload.salesCodeDetails || payload.SalesCodeDetails || [];
        this.salesCodeDetailOptions = details;

        // 下拉必须用 SalesCode；旧版过程第 1 结果集是 OfficeCode，应从明细去重
        if (details.length) {
          const codeSet = new Set();
          details.forEach((row) => {
            const code = row.salesCode || row.SalesCode;
            if (code) {
              codeSet.add(code);
            }
          });
          this.salesCodeListFromApi = Array.from(codeSet).sort();
        } else {
          const codes = payload.salesCodes || payload.SalesCodes || [];
          this.salesCodeListFromApi = Array.isArray(codes) ? codes : [];
        }
      });
    },
    handleSidebarHide(id) {
      const supplierDetailRef = this.$refs['supplier_detail'];
      const isInMyUsersTab = supplierDetailRef && supplierDetailRef.currentTab === 6;
      
      if (isInMyUsersTab && this.$store.state.dirty) {
        this.$store.state.dirty = false;
      }
      
      if (this.$store.state.dirty) {
        this.$swal({
          text: this.$t("lbl_EMPBE_LeaveWithoutSaving"),
          showCancelButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          confirmButtonColor: "#6e7881",
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
          cancelButtonColor: "#7066e0",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$refs["supplier"].hide();
            this.$store.state.dirty=false;
          }
        });
      } else {
        this.$refs["supplier"].hide();
      }
    },
    openSidebar(dataItem, fromUrl) {
      if (dataItem) {
        this.selectedDataItem = dataItem;
        this.selectedAccoountId = dataItem.accountId + "";
      }
      // 列表点击打开时清掉 deep-link 参数，避免 supplierDetail.refresh 再按 URL 切 tab
      if (!fromUrl) {
        const q = this.$route.query || {};
        if (q.type || q.tab || q.productId || q.catalogId) {
          const next = { ...q };
          delete next.type;
          delete next.tab;
          delete next.productId;
          delete next.catalogId;
          this.$router.replace({ query: next }).catch(() => {});
        }
      }
    },
    LoadSupplierData() {
       console.log('LoadSupplierData')
      this.loader = true;
      var that = this;
      var sortColumns = "";
      var sortDirections = "";
      that.sort.forEach((element) => {
        sortColumns += element.field + ",";
        sortDirections += element.dir + ",";
      });
      if (sortColumns.length > 0) {
        sortColumns = sortColumns.substring(0, sortColumns.length - 1);
        sortDirections = sortDirections.substring(0, sortDirections.length - 1);
      }
      that.currentPage = (that.skip + that.take) / that.take;
      adminService
        .GetSupplierList(
          JSON.stringify(that.filter),
          sortColumns,
          sortDirections,
          that.currentPage,
          that.take,
          that.salesPersonFilter.Selected,
          that.eBoothFilter.Selected
        )
        .then((res) => {
          that.items = res.supplierListingInfos;
          that.items.forEach(element => {
            element.eBoothGradeName = that.geteBoothGradeName(element)
          });
          that.totalRows = res.count;
          that.memberGradeList = res.memberGradeInfos;
          that.packageTypeList = res.packageNameInfos;
          that.gridData = that.getData(that.items);
          that.loader = false;
        })
        .finally(() => {
          if (that.isFirstLoad) {
            // URL: companyId / accountid → 打开右侧详情
            const companyId = that.$route.query.companyId || that.$route.query.accountid;
            if (companyId) {
              var currentItem = that.gridData.data.filter(
                (x) => x.accountId == companyId
              );
              that.searchWord = companyId;
              that.openSidebar(currentItem[0] || { accountId: companyId }, true);
              that.$root.$emit("bv::toggle::collapse", "supplier");
            }
            that.isFirstLoad = false;
          }
        });
    },
    pageChangeHandler(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
      this.currentPage = (event.page.skip + event.page.take) / event.page.take;
      this.LoadSupplierData();
    },
    onSelectionChange(event) {
      console.log('onSelectionChange')
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
      this.gridData = this.getData(this.items); //[wxy]重置密码：更新griddate,调用selectedDataItems，使选中的条数正确
    },
    onFilter(e) {
      this.skip = 0;
      this.filter = this.buildListFilter();
      this.LoadSupplierData();
    },
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      const tempData = this.items.map((item) => {
        return { ...item, selected: checked };
      });

      const tempGridData = this.gridData.data.map((item) => {
        return { ...item, selected: checked };
      });
      this.gridData.data = tempGridData;
      this.items = tempData;
    },
    getData(data) {
      // return data;
      return process(data, {
        // take: this.take,
        // skip: this.skip,
        // group: this.group,
        // sort: this.sort,
        // filter: this.filter,
      });
    },
    createAppState: function (dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.sort = dataState.sort;
      this.filter = dataState.filter;

      // this.gridData = this.getData(this.items);
      this.LoadSupplierData();
    },
    dataStateChange: function (event) {
      this.createAppState(event.data);
    },
    getCompanyNameWithLang(item) {
      return this.langid == "1252"
        ? item.companyNameEn
        : this.langid == "950"
          ? item.companyNameTc
          : item.companyNameSc;
    },
    getMemberGradeWithLang(item) {
      return this.langid == "1252"
        ? item.memberGradeEn
        : this.langid == "950"
          ? item.memberGradeTc
          : item.memberGradeSc;
    },
    geteBoothGradeName(item) {
      switch (item.eBoothGrade) {
        case "A":
          return this.$t('lbl_EMPBE_GradeA');
        case "B":
          return this.$t('lbl_EMPBE_GradeB');
        case "C":
          return this.$t('lbl_EMPBE_GradeC');
        default:
          if (item.MemberCode == 'BASIC') {
            return this.$t('lbl_emp2_BasicEbooth');
          } else if (item.isExhibitor) {
            return this.$t('lbl_EMPBE_FreeEBooth');
          } else {
            return "-"
          }
      }
    },
    getPackageNameArray(item) {
      var nameString = this.langid == "1252" ? item.packageNameEn : this.langid == "950" ? item.packageNameTc : item.packageNameSc;
      if(nameString == "" || nameString == undefined) return [];
      return nameString.split(',');
    },
    DisplayDate(dateString, defaultValue = "") {
      if (dateString == "0001-01-01 00:00:00") return defaultValue;
      try {
        var date = new Date(dateString);
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [
          date.getFullYear() + "/",
          (mm > 9 ? "" : "0") + mm + "/",
          (dd > 9 ? "" : "0") + dd,
        ].join("");
      } catch (ex) {
        return defaultValue;
      }
    },
    onColumnsSubmit(columnsState) {
      this.columns = columnsState;
    },
    showAlert(message) {
      this.$swal({
        html: message,
        htmlMode: true,
        //icon: variant, // 可以是 success、error、warning、info、question 等图标
        showConfirmButton: true, // 禁用确认按钮
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        //allowOutsideClick: false, // 防止点击外部关闭
        //allowEscapeKey: false, // 防止按下 ESC 键关闭
      });
    },
    resetPassword(accountId) {
      var selectedItems =
        accountId <= 0
          ? this.selectedDataItems
          : this.gridData.data.filter((x) => x.accountId == accountId);
      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        // } else if (accountId <= 0 && selectedItems.length > 10) {
        //   this.showAlert(this.$t("lbl_MaximumTenOptions"));
      } else {
        this.$swal({
          text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
          showCancelButton: true,
          type: "confirm",
          showConfirmButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        }).then((result) => {
          if (result.value) {
            var paramList = selectedItems.map((item) => ({
              accountId: item.accountId,
              langId: this.langid,
              isUat: false,
            }));
            adminService.SendForgetPasswordByAdmin(paramList).then((res) => {
              var msg = "";
              if (
                res.statusCode != 500 &&
                res.systemErrorMsg &&
                res.systemErrorMsg.length > 0
              ) {
                res.systemErrorMsg.forEach((element, index) => {
                  var tempArray = element.split(":");
                  const selectedAccount = selectedItems.find(
                    (item) => item.accountId == tempArray[0]
                  );
                  let displayName = "";
                  if (selectedAccount) {
                    displayName =
                      this.langid === 950
                        ? selectedAccount.companyNameTc
                        : this.langid === 1252
                          ? selectedAccount.companyNameEn
                          : selectedAccount.companyNameSc;
                  }
                  var tempStr =
                    displayName +
                    ": Email / " +
                    this.$t("lbl_Mobile") +
                    " " +
                    this.$t("lbl_EMPBE_grid_filterIsEmptyOperator") +
                    "<br>";
                  msg += tempStr;
                });
              } else {
                msg = res.systemErrorMsg.join("<br>");
              }
              if (res.data && res.data.length > 0) {
                res.data.forEach((element, index) => {
                  var selectedAccount = selectedItems.find(
                    (item) => item.accountId == element.data
                  );
                  let displayName = "";
                  if (selectedAccount) {
                    displayName =
                      this.langid === 950
                        ? selectedAccount.companyNameTc
                        : this.langid === 1252
                          ? selectedAccount.companyNameEn
                          : selectedAccount.companyNameSc;
                  }
                  if (element.isSuccessful) {
                    const temp = this.$t("lbl_EMPBE_ResetPasswordSendResult1");
                    msg += `${displayName}: ${temp}`;
                  } else {
                    const temp = this.$t("lbl_EMPBE_ResetPasswordSendResult2");
                    msg += `${displayName}: ${temp}`;
                  }
                });
              }
              this.showAlert(msg);
            });
          }
        });
      }
    },
    researchSubmit(accountId) {
      var selectedItems = accountId <= 0
        ? this.selectedDataItems
        : this.gridData.data.filter((x) => x.accountId == accountId);

      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        return;
      }

      const that = this;
      const companyNames = selectedItems.map((x) => x.companyField).join(", ");

      this.$swal({
        text: "Are you sure to submit company AI research preview with: " + companyNames,
        showCancelButton: true,
        type: "confirm",
        showConfirmButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then((result) => {
        if (!result.value) return;

        const companyIds = selectedItems.map((x) => x.accountId).join(",");
        const params = {
          companyIds,
        };

        adminService.SubmitAiResearchPreview(params).then((res) => {
          const msg = res.isSuccessful ? that.$t("lbl_EMPBE_SubmitSuccess") : that.$t("lbl_emp2_PopupFailedTitle");
          that.showAlert(msg);
        });
      });
    },
    researchCompany(accountId, triggerCode) {
      var selectedItems = accountId <= 0
        ? this.selectedDataItems
        : this.gridData.data.filter((x) => x.accountId == accountId);

      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        return;
      }

      const that = this;
      const companyNames = selectedItems.map((x) => x.companyField).join(", ");

      this.$swal({
        text: "Are you sure to do company research with: " + companyNames,
        showCancelButton: true,
        type: "confirm",
        showConfirmButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then((result) => {
        if (!result.value) return;

        const companyIds = selectedItems.map((x) => x.accountId).join(",");
        const params = {
          companyIds,
          triggerCode,
        };

        adminService.InsertAiCompanyResearchQueue(params).then((res) => {
          const msg = res.isSuccessful ? that.$t("lbl_EMPBE_SubmitSuccess") : that.$t("lbl_emp2_PopupFailedTitle");
          that.showAlert(msg);
        });
      });
    },
    submitReminder(accountId) {
      var selectedItems =
        accountId <= 0
          ? this.selectedDataItems
          : this.gridData.data.filter((x) => x.accountId == accountId);
      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        // } else if (accountId <= 0 && selectedItems.length > 10) {
        //   this.showAlert(this.$t("lbl_MaximumTenOptions"));
      } else {

        this.$swal({
          text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
          showCancelButton: true,
          type: "confirm",
          showConfirmButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        }).then((result) => {
          if (result.value) {
            var list = selectedItems.map((item) => ({
              accountId: item.accountId,
              langId: this.langid,
              // isUat: true,
            }));

            //Get Current User Login for Logging
            var currentUser = this.$store.state.authentication.user; 
            //var currentUser = JSON.parse(localStorage.getItem("user"));
            
            var currentLogin = "SYSTEM";
            if (currentUser != null){
              currentLogin = currentUser.login;
            }

            var paramList = {
              DetailList: list,
              action: {
                'LangId': localStorage.getItem('currentLangId')
                , 'IP': window.location.host
                , 'URL': window.location.href
                , 'Referral': document.referrer
                , 'BAgent': window.navigator.userAgent
                , 'Action': "SendReminderEmailAll"
                , 'ActionBy': currentLogin
              }
            }

            adminService.SubmitReminderEmail(paramList).then((res) => {
              var msg = "";
              if (!res.isSuccessful) {
                msg = res.systemErrorMsg.join("<br>");
              } else {
                msg = this.$t('lbl_EMPBE_SubmitReminderEmailSuccess')
              }
              this.showAlert(msg);
            });
          }
        })
      }
    },
    submitReminderAll() {
       this.$swal({
          text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
          showCancelButton: true,
          type: "confirm",
          showConfirmButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        }).then((result) => {
          if (result.value) {

            //Get Current User Login for Logging
            var currentUser = this.$store.state.authentication.user; 
            //var currentUser = JSON.parse(localStorage.getItem("user"));
            var currentLogin = "SYSTEM";
            if (currentUser != null){
              currentLogin = currentUser.login;
            }

            var paramList = {
              //ForDebug
              //IsTest: true,
              //TestEmail:"wardho@adsale.com.hk",

              IsTest: false,
              TestEmail:"",
              Source: "EMPBE_Admin",
              action: {
                'LangId': localStorage.getItem('currentLangId')
                , 'IP': window.location.host
                , 'URL': window.location.href
                , 'Referral': document.referrer
                , 'BAgent': window.navigator.userAgent
                , 'Action': "SendReminderEmailAll"
                , 'ActionBy': currentLogin
              }
            }

            adminService.SubmitReminderEmailAll(paramList).then((res) => {
              var msg = "";
              if (!res.isSuccessful) {
                msg = res.systemErrorMsg.join("<br>");
              } else {
                msg = this.$t('lbl_EMPBE_SubmitReminderEmailSuccess')
              }
              this.showAlert(msg);
            });
          }
        })
    },
    sendAccountPassword(accountId) {
      var selectedItems =
        accountId <= 0
          ? this.selectedDataItems
          : this.gridData.data.filter((x) => x.accountId == accountId);
      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        // } else if (accountId <= 0 && selectedItems.length > 10) {
        //   this.showAlert(this.$t("lbl_MaximumTenOptions"));
      } else {
        
        this.$swal({
          text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
          showCancelButton: true,
          type: "confirm",
          showConfirmButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        }).then((result) => {
          
          if (result.value) {
            var list = selectedItems.map((item) => ({
              accountId: item.accountId,
              langId: this.langid,
              // isUat: true,
            }));
            //Get Current User Login for Logging
            var currentUser = this.$store.state.authentication.user; 
            //var currentUser = JSON.parse(localStorage.getItem("user"));
            var currentLogin = "SYSTEM";
            if (currentUser != null){
              currentLogin = currentUser.login;
            }
            var paramList = {
              DetailList: list,
              action: {
                'LangId': localStorage.getItem('currentLangId')
                , 'IP': window.location.host
                , 'URL': window.location.href
                , 'Referral': document.referrer
                , 'BAgent': window.navigator.userAgent
                , 'Action': "SendAccountPassword"
                , 'ActionBy': currentLogin
              }
            }

            adminService.SendAccountPasswordEmail(paramList).then((res) => {
              var msg = "";
              if (!res.isSuccessful) {
                msg = res.systemErrorMsg.join("<br>");
              } else {
                msg = this.$t('lbl_EMPBE_SendAccountPasswordEmailSuccess')
              }
              this.showAlert(msg);
            });
          }
        })
      }
    },
  },
  provide() {
    return {
      sidebarIsOpen: computed(() => this.sidebarMenu)
    }
  },
};
</script>
<style>

.datatable-vue table tbody tr td {
  vertical-align: initial !important;
}

.table.b-table.b-table-selectable:not(.b-table-selectable-no-click)>tbody>tr {
  cursor: auto !important;
}

.actionBtn button {
  padding: 0.375rem 1.75rem !important;
}


.b-sidebar-backdrop {
  opacity: 0.2 !important;
}

.actionBtn > .dropdown-menu{
  overflow: auto;
  max-height: 300px;
}

.container-fluid .k-grid-container {
   min-height: 400px !important;
}

/* 确保 CatalogueModal 弹框显示在 supplier sidebar (z-index: 1041) 之上 */
/* 当 supplier sidebar 打开时，确保 CatalogueModal 显示在其上方 */
#CategoryModal {
  z-index: 1055 !important;
}

/* 确保 CatalogueModal 的背景遮罩也在 sidebar 之上 */
/* 只有当 CategoryModal 显示时才应用此样式 */
body.modal-open:has(#CategoryModal.show) .modal-backdrop,
#CategoryModal.show ~ .modal-backdrop {
  z-index: 1054 !important;
}
#supplier >.b-sidebar > .b-sidebar-header{
  align-items: center !important;
  justify-content:center !important;
}
 /* #supplier .card-header:nth-child(1){ 
  margin-left:35px ;
  background-color: rgba(0, 0, 0, 0.03);
    padding-top: 12px; 
  padding: .75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, .03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  border-top-left-radius: 15px ;
  border-top-right-radius: 15px;
  position: relative;
} */
/* #supplier > .b-sidebar-header:nth-child(1) {
      padding: 0.25rem;
      position: fixed; 
      z-index: 10001;
} */
/* #supplier >  .card-header:nth-child(1) {
    width: 93%;
    margin-left: 50px;
}    */
#supplier >.b-sidebar.b-sidebar-right > .b-sidebar-header .close{
  margin-right: 8px;
  position: absolute;
    left: 10px;
} 
#AdCPSOLExhibitorList >.b-sidebar.b-sidebar-right > .b-sidebar-header .close{
  margin-right: 8px;
  position: absolute;
    left: 10px;
} 
#SupplierList_grid td{
  word-break: break-all;
}

#SupplierList_grid {
  --supplier-toolbar-control-height: calc(1.5em + 0.75rem + 2px);
  max-width: 100%;
}

#SupplierList_grid .k-grid-toolbar.k-toolbar {
  align-items: center !important;
  overflow: visible !important;
}

#SupplierList_grid .supplier-toolbar-inner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  max-width: 100%;
  min-height: var(--supplier-toolbar-control-height);
  box-sizing: border-box;
}

#SupplierList_grid .supplier-toolbar-inner > .btn-group {
  margin: 0 !important;
  height: var(--supplier-toolbar-control-height);
  flex-shrink: 0;
}

#SupplierList_grid .supplier-toolbar-inner > .btn-group > .btn {
  height: var(--supplier-toolbar-control-height);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 0;
  padding-bottom: 0;
}

.supplier-toolbar-filter {
  width: 180px;
  flex-shrink: 0;
  height: var(--supplier-toolbar-control-height);
  margin: 0;
}

#SupplierList_grid .supplier-toolbar-filter ::v-deep .form-group {
  width: 100%;
  height: 100%;
  margin: 0 !important;
  padding: 0;
}

#SupplierList_grid .supplier-toolbar-filter ::v-deep .form-group > div {
  height: 100%;
}

#SupplierList_grid .supplier-toolbar-filter ::v-deep .vue-treeselect {
  height: 100%;
}

#SupplierList_grid .supplier-toolbar-filter ::v-deep .cps-treeselect .vue-treeselect__control {
  height: var(--supplier-toolbar-control-height) !important;
  min-height: var(--supplier-toolbar-control-height) !important;
  padding: 0.375rem 0.75rem !important;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 1rem;
  line-height: 1.5;
}

#SupplierList_grid .supplier-toolbar-filter ::v-deep .cps-treeselect .vue-treeselect__single-value,
#SupplierList_grid .supplier-toolbar-filter ::v-deep .cps-treeselect .vue-treeselect__placeholder {
  line-height: 1.5;
  font-size: 1rem;
}

#SupplierList_grid .supplier-toolbar-search.form-control {
  width: 200px;
  max-width: 100%;
  height: var(--supplier-toolbar-control-height);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  font-size: 1rem;
  flex-shrink: 0;
}

#SupplierList_grid .supplier-toolbar-search-btn {
  height: var(--supplier-toolbar-control-height);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding-top: 0;
  padding-bottom: 0;
}

#SupplierList_grid .k-grid-content {
  overflow-x: auto;
}
#supplier.b-sidebar {
    min-width: 800px !important;
    width: 95% !important;
}
#supplier .PublicTabs .tab-left-Big{
    width: 24%;
}
#supplier .PublicTabs .tab-center-Big{
    width: 72%;
}
#supplier #companyInfoForm .tab-left-tab,
#supplier #productInfoForm .tab-left-tab{
    flex: 0 0 calc((100% - 24px) * 0.25) !important;
    max-width: calc((100% - 24px) * 0.25) !important;
    width: auto !important;
}
#supplier #companyInfoForm .tab-center-tab,
#supplier #productInfoForm .tab-center-tab{
    flex: 1 1 0 !important;
    max-width: none !important;
    width: auto !important;
}
/* [20230908][wxy] _grid.css统一处理
.k-grid td {
  overflow: visible !important;
}

.k-grid-toolbar {
  overflow: visible !important;
}

.k-grid-container {
   min-height: 130px; 
} */
</style>
